module.exports = __webpack_public_path__ + "337b9da300fd98439415da168463731b.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/FM.svg
// module id = wi8u
// module chunks = 0